import React from "react";
import { useNavigate } from "react-router-dom";
import "./AppHome.css";

export default function WelcomePage() {
  const navigate = useNavigate();

  return (
    <div className="welcome-container2">
      <div className="welcome-Regi-card">
        <div className="icon-circle">✓</div>

        <h1>Your attendance has been marked successfully!</h1>
        <p>Thank you for your cooperation.</p>


      </div>
    </div>
  );
}
